import React from 'react';
import PropTypes from 'prop-types';
import BootstrapTable from 'react-bootstrap-table-next';
import Toolbar from '../../common/Toolbar';
import styles from './DropshipProductCardVariants.module.scss';
import { currencyFormat, stringOrDashFormatter } from '../../../utils/formatHelper';
import { variantSort2 } from '../../../utils/sortHelper';
import { sortCaret, getDynamicColumn } from '../../../utils/tableHelper';
import { upperFirst } from 'lodash';
import { useFeatureFlag } from '../../../hooks/useFeatureFlag';
import { showPricesRetailerSide } from '../../../constants/featureFlag';

function dataFormatColumn(cell, row, rowIndex, field) {
  return stringOrDashFormatter(row.options[field]);
}

function DropshipProductCardVariants(props) {
  const { variants } = props;

  const isShowPricesRetailerSideEnabled = useFeatureFlag(showPricesRetailerSide, false);

  const optionsColumns = getDynamicColumn(variants);

  const columns = [];

  optionsColumns.forEach((field) => {
    columns.push({
      text: upperFirst(field),
      dataField: field,
      sort: true,
      formatter: dataFormatColumn,
      formatExtraData: field,
    });
  });

  columns.push(
    {
      text: 'SKU',
      dataField: 'sku',
      sort: true,
    },
    {
      text: 'MSRP',
      dataField: 'retail_price',
      formatter: (cell, row) => currencyFormat(cell, row.currency),
    },
  );

  const uiColumns = columns.filter((column) => {
    if (column.dataField === 'retail_price') {
      return isShowPricesRetailerSideEnabled;
    }

    return true;
  });

  return (
    <div className={styles.container}>
      <Toolbar name="Variants" />

      <BootstrapTable
        data={variants}
        columns={uiColumns}
        keyField="id"
        striped
        hover
        bordered={false}
        className={styles.container}
        sort={{
          sortCaret,
          sortFunc: variantSort2,
        }}
        defaultSorted={[
          {
            dataField: optionsColumns.length ? optionsColumns[0] : 'sku',
            order: 'desc',
          },
        ]}
      ></BootstrapTable>
    </div>
  );
}

export default DropshipProductCardVariants;

DropshipProductCardVariants.propTypes = {
  variants: PropTypes.arrayOf(PropTypes.object).isRequired,
};
